import { AeThexProvider, useAeThex } from '@/components/AeThexProvider'
import MainLayout from '@/components/mockup/MainLayout'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAppDispatch } from '@/hooks/useRedux'
import { clearAuth } from '@/stores/authSlice'
import LoadingScreen from '@/components/LoadingScreen'

function ChatInner() {
  const ctx = useAeThex() as { loading: boolean; user: unknown } | null
  const loading = ctx?.loading ?? true
  const user = ctx?.user ?? null
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!loading && !user) {
      // Token was invalid — sync Redux state and go to login
      dispatch(clearAuth())
      navigate('/login', { replace: true })
    }
  }, [loading, user, navigate, dispatch])

  if (loading) {
    return <LoadingScreen label="Signing in…" />
  }

  if (!user) return null

  return <MainLayout />
}

export default function ChatPage() {
  return (
    <AeThexProvider>
      <ChatInner />
    </AeThexProvider>
  )
}
